import "./ElectricalInspection.module.css";
import Header from "@/reusable_sections/Header";
import ElektriciteitskeuringAanvragen from "./sections/ElektriciteitskeuringAanvragen";
import ElektriciteitsKeuringHoeWerktHet from "./sections/ElektriciteitsKeuringHoeWerktHet";
import GratisOfferte from "./sections/GratisOfferte";
import VeelgesteldeVragen from "./sections/VeelgesteldeVragen";
import Footer from "@/reusable_sections/Footer";
export default function ElectricalInspectionPage() {
  return <div>
      <Header />
      <ElektriciteitskeuringAanvragen />
      <ElektriciteitsKeuringHoeWerktHet />
      <GratisOfferte />
      <VeelgesteldeVragen />
      <Footer />
    </div>;
}